import React from "react";

const Page = () =>{
    return(
        <div>
            Sobre
        </div>
    );
}

export default Page;